import React from "react";
import { useSort } from "../utils/sort";
import { useFilter } from "../utils/filter";
import { Props } from "./type";
import { StatusFilter } from "./statusFilter";
import { Sort } from "./sort";
import { Filter } from "./filter";
import styles from "./styles.scss";

function Toolbar(props: Props) {
  const { filter, setFilter } = useFilter();
  const { sort, setSort } = useSort();

  return (
    <div className={styles.filters}>
      <Sort sort={sort} setSort={setSort} />
      <Filter filter={filter} setFilter={setFilter} />
      <StatusFilter
        statuses={filter.statuses}
        setStatuses={(statuses) => setFilter({ ...filter, statuses })}
      />
    </div>
  );
}

export { Toolbar };
